import { Injectable, Inject } from '@angular/core';
import { SystemGlobalsService } from '../system-globals.service';
import FroalaEditor from 'froala-editor';
import { CookieService } from 'ngx-cookie-service';
declare var $ :any;

@Injectable({
  providedIn: 'root'
})
export class FroalaService {

  currentEditor: any = null;

	showVideoUploadProgress: boolean = false;
  videoUploadProgress: number = 0;

  lockTables: boolean = false;
  dualImageLarge: boolean = false;

  private hasExtendedFunctionality: boolean = false;

  constructor(@Inject(SystemGlobalsService) public globals: SystemGlobalsService, private cookies: CookieService) {
    this.createTopLevelCallbacks();
  }

  extendFunctionality() {
    if (this.hasExtendedFunctionality) return;
    else this.hasExtendedFunctionality = true;

    FroalaEditor.ICON_DEFAULT_TEMPLATE = 'font_awesome_5';
    FroalaEditor.DefineIconTemplate('fa5b', '<i class="fab fa-[NAME]"></i>');

    FroalaEditor.DefineIcon('textColor', {SRC: '/img/font-color-icon.png', ALT: 'Font Color', template: 'image'});
    FroalaEditor.DefineIcon('undo', {NAME: 'undo'});
    FroalaEditor.DefineIcon('redo', {NAME: 'redo'});
    FroalaEditor.DefineIcon('specialCharacters', {NAME: 'Ω', template: 'text'});

    // Define popup template.
    $.extend(FroalaEditor.POPUP_TEMPLATES, {
      'addPdf.popup': '[_BUTTONS_][_CUSTOM_LAYER_]',
      'addImage.popup': '[_BUTTONS_][_CUSTOM_LAYER_]',
      'addVideo.popup': '[_BUTTONS_][_CUSTOM_LAYER_]',
      'addLinkImage.popup': '[_BUTTONS_][_CUSTOM_LAYER_]',
      'addSymbol.popup': '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    $.extend(FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose'],
    });

    function _initFroalaPopup(editor, pluginName, customLayer) {
      // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length >= 1) {
          popup_buttons += '<div class="fr-buttons" style="text-align: right;">' + editor.button.buildList(editor.opts.popupButtons) + '</div>';
        }

        // Load popup template.
        var template = {
          buttons: popup_buttons,
          custom_layer: customLayer
        };

        // Create popup.
        return editor.popups.create(pluginName + '.popup', template);
    }

    top['_showFroalaPopup'] = (editor, pluginName, pluginCmd, initPopup) => {
      // Get the popup object defined above.
        var $popup = editor.popups.get(pluginName + '.popup');
        if (!$popup) $popup = initPopup();

        // Set the editor toolbar as the popup's container.
        editor.popups.setContainer(pluginName + '.popup', editor.$tb);

        editor.popups.refresh(pluginName + '.popup');

        // Get the button's object in order to place the popup relative to it.
        var $btn = editor.$tb.find('.fr-command[data-cmd="' + pluginCmd + '"]');

        // Set the popup's position.
        var left = $btn.offset().left + $btn.outerWidth() / 2;
        var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);

        // The button's outerHeight is required in case the popup needs to be displayed above it.
        editor.popups.show(pluginName + '.popup', left, top, $btn.outerHeight());

        setTimeout(function() {$('.fr-popup .fr-buttons').click();}, 200);

        this.currentEditor = editor;
        //_gKoFroalaEditorManager.currentEditor(editor);
    }

    // The custom popup is defined inside a plugin (new or existing).
    FroalaEditor.PLUGINS.addPdf = function (editor) {
        // Create custom popup.
        function initPopup() {
            return _initFroalaPopup(editor, 'addPdf', '<iframe style="width: 41em;height: 32em;" src="' + editor['opts']['uploadPdfUrl'] + '"></iframe>');
        }

        // Show the popup
        function showPopup() {
          top['_showFroalaPopup'](editor, 'addPdf', 'addPDF', initPopup);
        }

        // Hide the custom popup.
        function hidePopup() {
            editor.popups.hide('addPdf.popup');
        }

        // Methods visible outside the plugin.
        return {
            showPopup: showPopup,
            hidePopup: hidePopup
        };
    };


    // The custom popup is defined inside a plugin (new or existing).
    FroalaEditor.PLUGINS.addImage = function (editor) {
        // Create custom popup.
        function initPopup() {
            return _initFroalaPopup(editor, 'addImage', '<iframe style="width: 41em;height: 32em;" src="' + editor['opts']['uploadImageUrl'] + '"></iframe>');
        }

        // Show the popup
        function showPopup() {
          top['_showFroalaPopup'](editor, 'addImage', 'insertImage', initPopup);
        }

        // Hide the custom popup.
        function hidePopup() {
            editor.popups.hide('addImage.popup');
        }

        // Methods visible outside the plugin.
        return {
            showPopup: showPopup,
            hidePopup: hidePopup
        };
    };


    // The custom popup is defined inside a plugin (new or existing).
    FroalaEditor.PLUGINS.addVideo = function (editor) {
        // Create custom popup.
        function initPopup() {
            return _initFroalaPopup(editor, 'addVideo', '<iframe style="width: 41em;height: 32em;" src="' + editor['opts']['uploadVideoUrl'] + '"></iframe>');
        }

        // Show the popup
        function showPopup() {
          top['_showFroalaPopup'](editor, 'addVideo', 'insertVideo', initPopup);
        }

        // Hide the custom popup.
        function hidePopup() {
            editor.popups.hide('addVideo.popup');
        }

        // Methods visible outside the plugin.
        return {
            showPopup: showPopup,
            hidePopup: hidePopup
        };
    };

    // The custom popup is defined inside a plugin (new or existing).
    FroalaEditor.PLUGINS.addLinkImage = function (editor) {
        // Create custom popup.
        function initPopup() {
            return _initFroalaPopup(editor, 'addLinkImage', '<iframe style="width: 41em;height: 32em;" src="' + editor['opts']['uploadLinkImageUrl'] + '"></iframe>');
        }

        // Show the popup
        function showPopup() {
          top['_showFroalaPopup'](editor, 'addLinkImage', 'addLinkImage', initPopup);
        }

        // Hide the custom popup.
        function hidePopup() {
            editor.popups.hide('addLinkImage.popup');
        }

        // Methods visible outside the plugin.
        return {
            showPopup: showPopup,
            hidePopup: hidePopup
        };
    };

    // Define custom popup close button icon and command.
    FroalaEditor.DefineIcon('popupClose', { NAME: 'times' });
    FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
        undo: false,
        focus: false,
        callback: function () {
          this.popups.hideAll();
        }
    });

    FroalaEditor.DefineIcon('addPDF', {NAME: 'file-pdf'});
    FroalaEditor.RegisterCommand('addPDF', {
      title: 'Insert PDF',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function () {
          this.addPdf.showPopup();
            return false;
        }
    });

    FroalaEditor.RegisterCommand('insertImage', {
        title: 'Insert Image',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function () {
          this.addImage.showPopup();
          return false;
        }
    });

    FroalaEditor.DefineIcon('addLinkImageIcon', {SRC: '/img/icon-dual-image.png', ALT: 'Insert Dual Size Image', template: 'image'});
    FroalaEditor.RegisterCommand('addLinkImage', {
       title: 'Insert Dual Size Image',
        focus: false,
        undo: false,
        icon: 'addLinkImageIcon',
        refreshAfterCallback: false,
        callback: function () {
          this.addLinkImage.showPopup();
          return false;
        }
    });

    FroalaEditor.DefineIcon('insertVideo', {NAME: 'youtube', template: 'fa5b'});
    FroalaEditor.COMMANDS.insertVideo.title = 'Embed Video';

    FroalaEditor.DefineIcon('attachVideo', {NAME: 'video'});
    FroalaEditor.RegisterCommand('attachVideo', {
        title: 'Insert Video/Sound',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function () {
          this.addVideo.showPopup();
          return false;
        }
    });

    FroalaEditor.DefineIcon('textAttributes', {NAME: 'font'});
    FroalaEditor.RegisterCommand('textAttributes', {
      title: 'Text Attributes',
        type: 'dropdown',
        focus: false,
            undo: false,
            refreshAfterCallback: true,
            html : function () {
              var options = '<button type="button" aria-label="Bold" class="fr-command fr-btn" data-cmd="bold"><i class="fa fa-bold"></i></button>';
              options += '<button type="button" aria-label="Italic" class="fr-command fr-btn" data-cmd="italic"><i class="fa fa-italic"></i></button>';
              options += '<button type="button" aria-label="Underline" class="fr-command fr-btn" data-cmd="underline"><i class="fa fa-underline"></i></button>';
              options += '<br><button type="button" aria-label="Strikethrough" class="fr-command fr-btn" data-cmd="strikeThrough"><i class="fa fa-strikethrough"></i></button>';
              options += '<button type="button" aria-label="Subscript" class="fr-command fr-btn" data-cmd="subscript"><i class="fa fa-subscript"></i></button>';
              options += '<button type="button" aria-label="Superscript" class="fr-command fr-btn" data-cmd="superscript"><i class="fa fa-superscript"></i></button>';
                return options;
        },
      }
    );

    FroalaEditor.RegisterCommand('customImageStyle', {
      title: 'Image Styles',
        type: 'dropdown',
        icon: 'imageStyle',
        refreshAfterCallback: true,
        html : function () {
           var options = '<ul class="fr-dropdown-list" role="presentation">';
             options += '<li><b>Any Combination</b></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="fr-rounded">Rounded</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="fr-bordered">Bordered</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageRoundedCorners">Rounded Corners</a></li>';
             options += '<li><b>Choose One</b></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="none">None</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageBlur">Blur</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageGrayscale">Grayscale</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageContrast">Contrast</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageSepia">Sepia</a></li>';
             options += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="customImageStyle" data-param1="imageShadow">Shadow</a></li>';
             options += '</ul>';

             return options;
        },
        callback : function(cmd, val, params) {
          var _img = this.image.get();

            if("imageBlur imageContrast imageGrayscale imageSepia imageShadow none".search(val) != -1)
                _img.removeClass('imageBlur imageContrast imageGrayscale imageSepia imageShadow none');

            this.image.applyStyle(val);
        },
        refreshOnShow : function(b, c) {
            var d = this.image.get();

            d && c.find(".fr-command").each(function() {
                var b = $(this).data("param1"), c = d.hasClass(b);
                $(this).toggleClass("fr-active", c).attr("aria-selected", c);
            });
        }
    });

    FroalaEditor.DefineIcon('quickResize', { NAME: 'arrows'});
    FroalaEditor.RegisterCommand('quickResize', {
      title: 'Quick Resize',
        icon: 'quickResize',
        type: 'dropdown',
        focus: false,
        undo: true,
        refreshAfterCallback: true,
        html:
          '<a style="cursor:pointer" class="fr-command xlarge-image" tabindex="-1" role="option" data-cmd="quickResize" data-param1="image-xlarge" title="Original (Max 1366w X 768h)" aria-selected="false"><img src="/img/icons/image-resize-xlarge.png"></a><br/>' +
          '<a style="cursor:pointer" class="fr-command" tabindex="-1" role="option" data-cmd="quickResize" data-param1="image-large" title="Original (Max 800w X 600h)" aria-selected="false"><img src="/img/icons/image-resize-large.png"></a><br/>' +
          '<a style="cursor:pointer" class="fr-command" tabindex="-1" role="option" data-cmd="quickResize" data-param1="image-medium" title="Medium (Max 600w X 400h)" aria-selected="false"><img src="/img/icons/image-resize-medium.png"></a><br/>' +
          '<a style="cursor:pointer" class="fr-command" tabindex="-1" role="option" data-cmd="quickResize" data-param1="image-small" title="Small (Max 400w X 300h)" aria-selected="false"><img src="/img/icons/image-resize-small.png"></a><br/>' +
          '<a style="cursor:pointer" class="fr-command responsive-image" tabindex="-1" role="option" data-cmd="quickResize" data-param1="image-responsive" title="Responsive image (Max 100%w X 768h)" aria-selected="false"><img src="/img/icons/image-responsive.svg" style="width: 32px; height: 32px;"></a>'
        ,
        callback: function (cmd, val, params) {
            var _img = this.image.get();
            _img.removeClass('image-small image-medium image-large  image-xlarge image-responsive');
            _img.css({width: 'auto', height: 'auto'});

            this.image.applyStyle(val);

            if (!_img.parent('a').hasClass('dual-size-image')) {
              var responsiveImageHtml = _img.get(0).outerHTML;

              if (val == "image-responsive") {
                  responsiveImageHtml = '<a class="responsive-image-container" style="cursor: default;">' + _img.get(0).outerHTML + '</a>';
              }

              this.image.remove(_img);
              this.html.insert(responsiveImageHtml, true);

              // Updates observable that has html body of a page
              this.events.trigger('contentChanged');
          }
        },
    });

    // AI-generated image actions. These are registered globally, so they reach the
    // owning Angular component through a handler object placed on the editor's
    // options (readable here as this.opts.aiImage) — the same per-editor hand-off
    // the custom popups use for uploadPdfUrl/uploadImageUrl. Editors that don't
    // supply an aiImage handler simply never show the buttons.

    // Icon + wording, so the image popup reads as labelled actions rather than a
    // row of bare glyphs. Froala substitutes any [KEY] from the icon definition.
    FroalaEditor.DefineIconTemplate(
      'ai_labelled',
      '<i class="fas fa-[FA5NAME]" aria-hidden="true"></i><span class="fr-ai-btn-label">[LABEL]</span>'
    );

    // The src of the image whose popup is currently open, or '' when there is none.
    function _aiImageSrc(editor) {
      var $img = editor.image.get();
      return ($img && $img.length) ? ($img.attr('src') || '') : '';
    }

    // Froala's image popup is just a row of buttons, so the heading — and the
    // marker class the vertical layout is keyed off — are added to the popup DOM
    // here. Rewritten on every refresh because the same popup is reused for
    // whichever image is selected next.
    function _decorateAiPopup(editor, text) {
      var popup = _aiPopupEl(editor);

      if (!popup) return;

      popup.classList.add('fr-ai-image-popup');

      var title = popup.querySelector('.fr-ai-popup-title');

      if (!title) {
        title = document.createElement('div');
        title.className = 'fr-ai-popup-title';
        popup.insertBefore(title, popup.firstChild);
      }

      title.textContent = text;
    }

    function _aiPopupEl(editor) {
      var $popup = editor.popups.get('image.edit');

      return ($popup && $popup.length) ? $popup.get(0) : null;
    }

    // Shared by the two AI buttons: show/hide via Froala's own fr-hidden class
    // (its DOM wrapper is not jQuery and has no .toggle()), and keep the popup
    // heading in step with the image the popup is open for.
    function _refreshAiButton($btn, editor, allowed) {
      var src = _aiImageSrc(editor);
      var handler = editor.opts.aiImage;
      var show = !!(src && handler && allowed(handler, src));

      $btn.toggleClass('fr-hidden', !show);

      if (src && handler) {
        _decorateAiPopup(editor, handler.title(src));
      }
    }

    FroalaEditor.DefineIcon('aiImageRegenerate', { NAME: 'magic', LABEL: 'Regenerate', template: 'ai_labelled' });
    FroalaEditor.RegisterCommand('aiImageRegenerate', {
      title: 'Replace this image with an AI-generated one',
      icon: 'aiImageRegenerate',
      focus: false,
      // The result is applied by replacing the whole page HTML from the server
      // response, so this must not push a step onto Froala's undo stack.
      undo: false,
      refreshAfterCallback: false,
      callback: function () {
        var src = _aiImageSrc(this);

        if (!src || !this.opts.aiImage) return;

        // The modal that follows would otherwise open underneath this popup.
        this.popups.hideAll();
        this.opts.aiImage.regenerate(src, this);
      },
      refresh: function ($btn) {
        _refreshAiButton($btn, this, function (h, src) { return h.canRegenerate(src); });
      },
    });

    FroalaEditor.DefineIcon('aiImageRevert', { NAME: 'undo', LABEL: 'Revert', template: 'ai_labelled' });
    FroalaEditor.RegisterCommand('aiImageRevert', {
      title: 'Restore the image this one replaced',
      icon: 'aiImageRevert',
      focus: false,
      undo: false,
      refreshAfterCallback: false,
      callback: function () {
        var src = _aiImageSrc(this);

        if (!src || !this.opts.aiImage) return;

        // The modal that follows would otherwise open underneath this popup.
        this.popups.hideAll();
        this.opts.aiImage.revert(src, this);
      },
      refresh: function ($btn) {
        _refreshAiButton($btn, this, function (h, src) { return h.canRevert(src); });
      },
    });

    // Froala anchors the image popup under the image, which puts it on top of a
    // large image's content. There is room in the left margin of the preview
    // pane, so move it alongside instead. Runs for the AI editor only — every
    // other editor keeps Froala's default placement.
    FroalaEditor.PLUGINS.aiImagePopup = function (editor) {
      var GAP = 12;
      var EDGE = 8;

      function reposition() {
        if (!editor.opts.aiImage) return;

        var popup = _aiPopupEl(editor);
        var $img = editor.image.get();
        var img = ($img && $img.length) ? $img.get(0) : null;

        if (!popup || !img || !popup.offsetWidth) return;

        // The popup is absolutely positioned inside the scrollable container, so
        // left/top are measured from that element's padding box.
        var container = popup.offsetParent;

        if (!container) return;

        var cRect = container.getBoundingClientRect();
        var iRect = img.getBoundingClientRect();
        var width = popup.offsetWidth;
        var height = popup.offsetHeight;

        var originLeft = cRect.left + container.clientLeft - container.scrollLeft;
        var originTop = cRect.top + container.clientTop - container.scrollTop;

        var left = iRect.left - originLeft - width - GAP;

        // No room to the left of the image — sit against its right edge instead.
        if (left < EDGE) {
          left = iRect.right - originLeft + GAP;
        }

        // Keep the popup inside the part of the pane the user can actually see,
        // so it stays reachable next to a very tall image.
        var top = iRect.top - originTop + EDGE;
        var minTop = container.scrollTop + EDGE;
        var maxTop = container.scrollTop + container.clientHeight - height - EDGE;

        top = Math.min(Math.max(top, minTop), Math.max(minTop, maxTop));

        popup.style.left = Math.round(left) + 'px';
        popup.style.top = Math.round(top) + 'px';
      }

      return {
        _init: function () {
          // Froala nudges the popup again immediately after the show event, so
          // wait a frame before overriding its position.
          editor.events.on('popups.show.image.edit', function () {
            editor.win.requestAnimationFrame(reposition);
          });
        }
      };
    };

    // Froala's own imageRemove, relabelled — retitling the built-in would change
    // it for every editor in the app.
    FroalaEditor.DefineIcon('aiImageRemove', { NAME: 'trash', LABEL: 'Remove', template: 'ai_labelled' });
    FroalaEditor.RegisterCommand('aiImageRemove', {
      title: 'Remove this image',
      icon: 'aiImageRemove',
      focus: false,
      callback: function () {
        this.image.remove();
      },
    });
  }

  createTopLevelCallbacks() {
    // Set lock tables based on cookie for user
    if (this.cookies.get('lockTables') == undefined) this.cookies.set('lockTables', 'false', 365);
    else this.lockTables = this.cookies.get('lockTables') == 'true' ? true : false;

    // Set lock tables based on cookie for user
    if (this.cookies.get('dualImageLarge') == undefined) this.cookies.set('dualImageLarge', 'false', 365);
    else this.dualImageLarge = this.cookies.get('dualImageLarge') == 'true' ? true : false;

    // defaultEditorOptions.tableResizer = !self.lockTables();

    var systemGlobals = this.globals;

    top['insertImage'] = image => {
      this.closeFroalaPopups();
      this.insertImage(image);
    };

    top['insertLinkImage'] = image => {
      this.closeFroalaPopups();
      this.insertLinkImage(image);
    };

    top['attachImage'] = data => {
      this.closeFroalaPopups();
      this.attachImage(data);
    };

    top['videoFileCallback'] = data => {
      this.closeFroalaPopups();

      this.videoUploadProgress = 100;
      this.insertVideo(data['path'], true, false, false);
    };

    top['mediaFileCallback'] = data => {
      this.closeFroalaPopups();

      let currentReferenceFolder = '/files/media_library/' + systemGlobals.constants._g_networkID;
      let file = data['path'];
      let filename = file.substr(file.indexOf('/') + 1, file.length);
      let filePath = currentReferenceFolder + filename;

      top['uploadEmbedFile']({url: filePath});
    };

    top['referenceFileCallback'] = data => {
      this.closeFroalaPopups();

        let currentReferenceFolder = "/files/reference_library/" + systemGlobals.constants._g_networkID;
        let filePath = currentReferenceFolder + data;
        let filename = data.substr(1, data.length) || data;

        top['uploadEmbedFile']({url: filePath});
    };

    top['uploadEmbedFile'] = file_data => {
      this.closeFroalaPopups();
      this.addEmbedFile(file_data.url);
    };

    // Old callback, kept for legacy use as some tabs target this
    top['upload_embed_file'] = function(data) {
      top['uploadEmbedFile'](data);
    };

    top['init_video_progress'] = () => {
      this.closeFroalaPopups();
      $('#gritter-notice-wrapper').show();
    }

    top['video_progress'] = {
      parent: this,
      $gritter: $('#gritter-notice-wrapper'),
      init: (function (data) {
          this.parent.closeFroalaPopups();
      }),
      done: (function (data) {
      }),
      insert: (function (file_path, name) {
          this.start_real_upload(file_path, name);
      }),
      start_real_upload: (function (path, name) {
          this.parent.insertVideo(path, false, false, true);
      }),
      create: (function (data) {
      }),
      update: (function (data) {
      }),
      set_progress: (function (data, $el) {
          var progress = +data['delegatedEvent']['loaded'] / +data['delegatedEvent']['total'] * 100;
      })
    };
  }

	closeFroalaPopups() {
		this.currentEditor.popups.hideAll();
  };

	insertImage(image) {
    let imageHtml = '<img src="' + image.large_url + '">';

    if (image.fromMediaLibrary){
      imageHtml = '<img src="' + image.large_url + '" style="max-width:800px; max-height:600px;">';
    }

    this.addImage(imageHtml);
  };

  insertLinkImage(image) {
    var thumbnailSize = 'style="max-width:800px; max-height:600px;"';
    var largeImagePath = image.fromMediaLibrary ? image.large_url : image.custom_url;

    if (!this.dualImageLarge) thumbnailSize = 'style="max-width:440px; max-height:320px;"';

    let imageHtml: string = '<a class="dual-size-image" href="' + largeImagePath + '" target="_blank"><img src="' + image.medium_url + '" ' + thumbnailSize + '></a>';

    this.addImage(imageHtml);
  };

  attachImage(data) {
    let current_attach_folder = "/files/email_attachments/0";
    let file_path = current_attach_folder + data;
    let filename = data.substr(1, data.length) || data;

    let imageHtml = '<img src="' + window.location.origin + file_path + '" />';

    this.addImage(imageHtml);
	};

  addImage(imageHtml) {
    this.currentEditor.html.insert(imageHtml, true);
    this.currentEditor.events.trigger('contentChanged');
	};

  insertVideo = function(video, isMediaLibrary, isAudio, isVimeo) {
    // let mediaFolder = "/files/media_library/" + this.globals.constants._g_networkID + "/";
    // let filename = video.substr(video.lastIndexOf('/') + 1, video.length);
    // let filePath = '/' + video.substring(video.indexOf('/') + 1);

    // if (isMediaLibrary) filePath = mediaFolder + filePath;
    let filename = video.substr(video.lastIndexOf('/') + 1, video.length);

    $.ajax({
        url: "/content/uploadVideo/ContentHtml",
        dataType: "json",
        type: 'POST',
        data: {
            path: video.substring(7),
            name: filename,
            id: 0
        },
        success: response => {
            this.showVideoUploadProgress = false;

            if (response.status == 2) {
              var vidId;
              vidId = response.result.replace.match(/content\/showVideo\/(.*?)"/);
              // else vidId = response.result.replace.match(/view.vzaar.com\/(.*?)\//);

              vidId = vidId[1];

              var vidHtml = response.result.replace;

              this.writeVideo(vidId, vidHtml, video);
            }
        }
    });
  };

  writeVideo = function(vidId, vidHtml, origFilePath) {
    var videoHtml = $(vidHtml).attr('data-vidId', vidId);
    var origVideoHtml = '<video class="original-video" width="560" height="350" data-vidId="' + vidId + '" preload="none" controls><span class="fr-video fr-dvb fr-draggable" contenteditable="false" draggable="true"><source src="' + origFilePath + '"></source></span></video>';

    // Insert video html using selected editor
    var $resizableVideo = '<span class="fr-video fr-dvb fr-draggable" contenteditable="false" draggable="true">' + $(videoHtml)[0].outerHTML + '</span>';
    this.currentEditor.html.insert($resizableVideo + origVideoHtml, false);

    // Updates observable that has html body of a page
    this.currentEditor.events.trigger('contentChanged');

    // $('#addMediaDialog').modal("hide");
    // self.showVideoUploadProgress(false);
  };

	addEmbedFile(file_url) {
    let url = '/modules/viewer?url=' + file_url;
		let iframe = '<iframe src="' + url + '" width="100%" height="780" style="border: none;"></iframe>';

		this.currentEditor.html.insert(iframe, true);

		// Updates observable that has html body of a page
		this.currentEditor.events.trigger('contentChanged');
	};
}
